import {
  join
} from '../../../lib/Array.lib';
import Core from '../../../lib/Core';
import globalErrorHandler from '../../../lib/Error/globalErrorHandler.fun';
import {
  composeCopyText,
  joinHTML
} from '../../../lib/HTML.lib';
import {
  trim
} from '../../../lib/String.lib';
import copyHtml from '../../../lib/tools/copyHtml';
import copyText from '../../../lib/tools/copyText.tool';

export default async function copyATS({
  prepend = '',
  html = '',
  htmlFormat = false
} = {}) {
  try {
    prepend = trim(prepend);
    const CONTENT = join(
      [
        prepend,
        htmlFormat
          ? joinHTML(html)
          : composeCopyText(html)
      ],
      htmlFormat ? '<br/>' : '\n'
    );
    console.debug({
      prepend,
      html,
      htmlFormat,
      CONTENT
    });
    if (
      htmlFormat
        ? await copyHtml(CONTENT)
        : await copyText(CONTENT)
    ) {
      Core.showMessage('Copied ATS!');
    }
    else {
      Core.showMessage('Fail copy ATS!');
    }
  }
  catch (error) {
    globalErrorHandler(error);
  }
}
